
const Cliente = () => {
    return(
        <div>Client List</div>
    );
}

export default Cliente;